"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var applyConversationActionRequest_1 = require("owa-service/lib/factory/applyConversationActionRequest");
var conversationAction_1 = require("owa-service/lib/factory/conversationAction");
var folderId_1 = require("owa-service/lib/factory/folderId");
var itemId_1 = require("owa-service/lib/factory/itemId");
var targetFolderId_1 = require("owa-service/lib/factory/targetFolderId");
var applyConversationActionOperation_1 = require("owa-service/lib/operation/applyConversationActionOperation");
var Utils_1 = require("owa-service/lib/Utils");
/**
 * Issue the service request to update categories of specified conversations
 * @param conversationActionContexts the conversation context to be categorized
 * @param contextFolderId the context folder id that the conversation belongs to
 * @param categoriesToAdd the categories to be added to the conversations
 * @param categoriesToRemove the categories to be removed from the conversations
 * @param clearCategories whether to clear categories
 * @return a promise which contains ApplyConversationActionResponseMessage
 */
function updateConversationsCategoriesService(conversationActionContexts, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories) {
    var requestBody = configureRequestBody(conversationActionContexts, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories);
    return applyConversationActionOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = updateConversationsCategoriesService;
/**
 * Configure the ApplyConversationActionRequest
 * @param conversationActionContexts the conversation context to be categorized
 * @param contextFolderId the context folder id that the conversation belongs to
 * @param categoriesToAdd the categories to add to the conversations
 * @param categoriesToRemove the categories to be removed from the conversations
 * @param clearCategories whether to clear categories
 * @return an ApplyConversationActionRequest
 */
function configureRequestBody(conversationActionContexts, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories) {
    var conversationActions = conversationActionContexts.map(function (conversationContext) {
        return createCategorizeConversationAction(conversationContext, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories);
    });
    return applyConversationActionRequest_1.default({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: false,
    });
}
/**
 * Configure the ApplyConversationActionRequest
 * @param conversationContext the conversation context to be categorized
 * @param contextFolderId the context folder id that the conversation belongs to
 * @param categoriesToAdd the categories to be added to the conversations
 * @param categoriesToRemove the categories to be removed to the conversations
 * @param clearCategories the categories to be removed to the conversations
 * @return the generated ConversationAction
 */
function createCategorizeConversationAction(conversationContext, contextFolderId, categoriesToAdd, categoriesToRemove, clearCategories) {
    var categorizeAction = conversationAction_1.default({
        Action: 'UpdateAlwaysCategorizeRule',
        ConversationId: itemId_1.default({ Id: conversationContext.conversationId }),
        Categories: categoriesToAdd,
        CategoriesToRemove: categoriesToRemove,
        ClearCategories: clearCategories,
    });
    // folderId can be null in search mode.
    if (contextFolderId) {
        var targetFolderId = targetFolderId_1.default({
            BaseFolderId: folderId_1.default({
                Id: contextFolderId,
            }),
        });
        categorizeAction.ContextFolderId = targetFolderId;
    }
    return categorizeAction;
}
//# sourceMappingURL=updateConversationsCategoriesService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/updateConversationsCategoriesService.js
// module id = 5668
// module chunks = 62